export const AMENITIES_POOL = [6,73,88,89,90,128]
export const AMENITIES_PARKING = [106,107,108,132,162,184,194]
